<ng-template #preHeader>
    SIGN IN / SIGN UP
</ng-template>
<ng-template #intro>
    {{description}}
</ng-template>


<shared-auth-wrapper>
    <shared-auth-header preHeaderMarginTop="lg" marginBottom="xlg" [preHeader]="preHeader"
        [description]="description ? intro : null">
        Looks like you’re new here
    </shared-auth-header>

    <ng-template #left>
        <shared-btn width="extended" feel="secondary" (onClick)="handleLinkRewardsAccountClick($event)">Link Rewards
            Account
        </shared-btn>
    </ng-template>

    <ng-template #right>
        <shared-btn width="extended" (onClick)="handleCreateNewProfileClick($event)">Create new profile</shared-btn>
    </ng-template>
    <shared-two-columns class="auth-for-rewards-account-linking-info__actions" [left]="left" [right]="right">
    </shared-two-columns>
</shared-auth-wrapper>